module.exports = __webpack_public_path__ + "img/_SDI9703-2-1000.53beb4bc.webp";